import script from "./productCard.vue?vue&type=script&setup=true&lang=js"
export * from "./productCard.vue?vue&type=script&setup=true&lang=js"

import "./productCard.vue?vue&type=style&index=0&id=2bd7b279&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd7b279"]])

export default __exports__